:host {
    display: flex;

    ti-image {
        margin: 0 auto;

        .ti-image-object {
            margin: 0 auto;
            max-height: 85px !important;
        }

        &[src*="undefined"] {
            opacity: 0.5;
        }
    }

    .ti-product-synopsis-details {
        display: flex;
        flex-direction: column;
        width: 100%; //fix ie text overflow issue

        > ti-titled-description {
            margin-bottom: $polaris-space-2;
        }

        .ti-product-synopsis-title {
            align-items: center;
            margin-bottom: $polaris-space-1;
            display: flex;
            flex-wrap: wrap;
        }
    }

    ::slotted([slot="product-family"]) {
        color: $pl-text-color-primary !important;
        flex-wrap: nowrap;
        font-size: $polaris-font-size-1;
        line-height: $polaris-line-height-1;
        margin-bottom: $polaris-space-2;
        text-decoration: none;
        text-transform: uppercase;
    }

    ::slotted([slot="product-link"]) {
        color: $pl-link-color-primary;
        display: flex;
        flex-direction: column;
        font-size: $polaris-font-size-3 !important;
        font-weight: $polaris-font-weight-bold;
        margin-right: $polaris-space-3;
        line-height: $polaris-line-height-3;
        justify-content: center;
        text-decoration: none;
    }

    ::slotted([slot="new-badge"]) {
        color: $pl-text-color-accent !important;
        font-size: $polaris-font-size-1;
        font-weight: $polaris-font-weight-bold;
        height: 24px;
        line-height: $polaris-line-height-3;
        position: relative;
    }

    ::slotted([slot="description"]) {
        color: $pl-text-color-primary !important;
        line-height: $polaris-line-height-2;
        text-decoration: none;
    }

    ::slotted([slot="product-status"]) {
        display: flex;
        flex-direction: column;
        height: 24px;
        justify-content: center;
    }

    ::slotted([slot="comment"]) {
        font-style: italic;
        display: block;
        line-height: $polaris-line-height-2;
    }
}

:host(.ti-product-synopsis-horizontal) {

    .ti-product-synopsis-container {
        display: flex;
        flex-direction: row;

        .ti-product-synopsis-image {
            flex-shrink: 0;
            height: auto;
            margin-top: -$polaris-space-3;
            margin-right: $polaris-space-4;
            width: 120px;

            ti-image {
                width: 100%;
                &[src*="illustrative-icons"] {
                   width: 100px;
                }
            }

            @media only screen and (max-width: 1239px) {
                display: none;
            }
        }
    }

    ::slotted([slot="new-badge"]) {
        padding-left: $polaris-space-4;

        &::before {
            content: "";
            border-top: 1px solid $polaris-palette-grey7;
            left: 5px;
            position: absolute;
            top: 11px;
            width: 6px;
        }
    }
}

:host(.ti-product-synopsis-vertical) {

    .ti-product-synopsis-container {
        display: flex;
        flex-direction: column;
        width: 100%;

        .ti-product-synopsis-image {
            margin-bottom: $polaris-space-8;
            width: 100%;

            ti-image {
                width: 216px;
            }
        }
    }

    ::slotted([slot="product-family"]) {
        margin-bottom: $polaris-space-6;
    }
}
